import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["resultMLOptionId"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { View } from 'foundations-components/components/View';
import { ACADEMY_PAGE_MAX_WIDTH, useMediaQuery } from 'academy-common-lib/utils/Styling';
import getLang from '../../../utils/getLang';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { CardsSection } from '../../cardsSection/components/CardsSection';
import { getSearchUrl } from '../../search/searchRouting';
import { useSearchFeedback } from '../../search/searchQueries';
import Raven from 'raven-js';
import { useSearch } from 'academy-common-lib/features/search/hooks/useSearch';
import { jsx as _jsx } from "react/jsx-runtime";
const useHubspotPlaylistsSection = () => {
  const {
    searchResults,
    searchResultsLoading,
    searchResultsError,
    correlationId
  } = useSearch({
    variables: {
      contentTypes: ['LEARNING_PATH'],
      languages: [getLang().toUpperCase()],
      pageLength: 3,
      offset: {
        cursor: 0
      }
    }
  });
  const {
    cardModels,
    cardModelsError,
    cardModelsLoading
  } = useLearningContentCardModels({
    items: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(({
      id,
      resultMLOptionId
    }) => ({
      id,
      type: 'LEARNING_PATH',
      resultMLOptionId
    }))) || [],
    skip: !(searchResults !== null && searchResults !== void 0 && searchResults.length)
  });
  return {
    playlists: cardModels,
    error: searchResultsError || cardModelsError,
    loading: searchResultsLoading || cardModelsLoading,
    correlationId
  };
};
const HubspotPlaylistsSection = () => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const [sendSearchFeedback] = useSearchFeedback();
  const {
    playlists,
    loading,
    error,
    correlationId
  } = useHubspotPlaylistsSection();
  const handleOnItemClick = _ref => {
    let {
        resultMLOptionId
      } = _ref,
      item = _objectWithoutPropertiesLoose(_ref, _excluded);
    if (!correlationId) {
      return;
    }
    sendSearchFeedback({
      variables: {
        correlationId,
        contentContainerType: item.type,
        resultMLOptionId
      }
    }).catch(Raven.captureException.bind(Raven));
  };

  // This prevents the section from displaying until we know that the playlists exist in the language if it's not English
  // We can remove this once we have playlists in all other languages
  // For English, we will continue to display the skeleton cards until the playlists are loaded
  if (getLang() !== 'en' && !(playlists !== null && playlists !== void 0 && playlists.length)) {
    return null;
  }
  if (error) {
    return null;
  }
  if (!loading && (!(playlists !== null && playlists !== void 0 && playlists.length) || playlists.length < 3)) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-recessed",
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      insetBlockStart: "-1px",
      marginBlock: "0",
      marginInline: "auto",
      maxInlineSize: `${ACADEMY_PAGE_MAX_WIDTH}px`,
      paddingBlock: isMobile ? '400' : '900',
      paddingInline: isMobile ? '400' : '1100',
      position: "relative",
      zIndex: 1,
      children: /*#__PURE__*/_jsx(CardsSection, {
        appearsIn: "homepage-playlists",
        content: playlists,
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.hubspotPlaylists.explorePlaylists"
        }),
        displayFullCardsOnMobile: false,
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.hubspotPlaylists.hubspotPlaylists"
        }),
        headerActions: /*#__PURE__*/_jsx(RouterLink, {
          to: getSearchUrl({
            contentType: 'LEARNING_PATH'
          }),
          children: isTablet ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.hubspotPlaylists.viewAllMobile"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.hubspotPlaylists.viewAll"
          })
        }),
        isLoading: loading,
        onItemClick: handleOnItemClick,
        size: "extra-large",
        use: "on-surface-recessed"
      })
    })
  });
};
export default HubspotPlaylistsSection;